// C1 long-format: population records are stored one per sex — 'male',
// 'female', or 'combined' (a single count covering both sexes).

// Lower-case sex code of a (normalized or raw) population record.
export function sexCode(row) {
  return String(row?.sex ?? '').trim().toLowerCase();
}
